import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";

const SideBySideSection = ({ slice }) => {
  const image = getImage(slice.primary.section_image);

  const isRight = slice.primary.section_image_position;

  return (
    <section
      className={`side-by-side ${isRight ? "right" : "left"}`}
    >
      <div className="side-by-side__image">
        <GatsbyImage
          image={image}
          alt={slice.primary.section_image.alt || ""}
          imgStyle={{ objectFit: "cover" }}
        />
      </div>

      <div className="side-by-side__content">
        <PrismicRichText
          field={slice.primary.section_content.richText}
        />
      </div>
    </section>
  );
};

export default SideBySideSection;